import { ROOT_SERVER_URL } from '../config';
import { collectQueryParams, request } from '../utils';

export function getAccount() {
  return request(`${ROOT_SERVER_URL}/api/aws/account`);
}

export function getPolicies(groupId) {
  return request(`${ROOT_SERVER_URL}/api/aws/iam/role/policies/${groupId}`);
}

export function getRestoreRequests(urlParams) {
  const urlSearchParams = collectQueryParams(urlParams);
  return request(`${ROOT_SERVER_URL}/api/aws/s3/request?${urlSearchParams}`);
}

export function getRestoreRequest(jobId) {
  return request(`${ROOT_SERVER_URL}/api/aws/s3/request/${jobId}`);
}

export function requestRestore(data) {
  return request(`${ROOT_SERVER_URL}/api/aws/s3/request`, {
    method: 'POST',
    data,
  });
}

export function approveRestoreRequest(jobId, data) {
  return request(`${ROOT_SERVER_URL}/api/aws/s3/approve/${jobId}`, {
    method: 'POST',
    data,
  });
}

export function cancelRestoreRequest(jobId, data) {
  return request(`${ROOT_SERVER_URL}/api/aws/s3/cancel/${jobId}`, {
    method: 'POST',
    data,
  });
}

export function countRestoreRequest(jobId) {
  return request(`${ROOT_SERVER_URL}/api/aws/s3/count/${jobId}`, {
    method: 'POST',
  });
}
